import { render } from "./Mas.vue?vue&type=template&id=27460f7d&scoped=true"
import script from "./Mas.vue?vue&type=script&lang=js"
export * from "./Mas.vue?vue&type=script&lang=js"

import "./Mas.vue?vue&type=style&index=0&id=27460f7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27460f7d"]])

export default __exports__